/* ADN · Menú móvil drill-down — controlador NR-nativo (Chrome · Fase 2).
   Motor propio; el NavMobile de Empire queda apagado (no se renderiza site-mobile-nav
   y la hamburguesa usa data-nr-menu-toggle). Un solo motor por superficie.
   Backend = linklist de Shopify (render en nr-mobile-menu.liquid). Aquí solo el control. */
(function () {
  function init() {
    var root = document.querySelector('[data-nr-menu]');
    if (!root) return;

    var stage = root.querySelector('[data-nrm-stage]');
    var titleEl = root.querySelector('[data-nrm-title]');
    var backBtn = root.querySelector('[data-nrm-back]');
    var drawer = root.querySelector('.nrm-drawer');
    var stack = [];
    var z = 10;
    var lastFocus = null; /* gestión de foco (veredicto H12 barrido web): lo que aria-modal promete */

    function focusables() {
      var els = drawer.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      return Array.prototype.filter.call(els, function (el) { return el.offsetParent !== null; });
    }

    function updateChrome() {
      if (stack.length === 0) {
        titleEl.textContent = 'Menú';
        root.classList.remove('nrm--drilled');
      } else {
        var top = stack[stack.length - 1];
        titleEl.textContent = top.getAttribute('data-nrm-title') || 'Menú';
        root.classList.add('nrm--drilled');
      }
    }

    function resetStack() {
      stack.forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
        p.style.zIndex = '';
      });
      stack = [];
      z = 10;
      updateChrome();
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      root.classList.add('nrm--open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('nrm-locked');
      var first = focusables()[0];
      if (first) first.focus();
    }

    function closeDrawer() {
      root.classList.remove('nrm--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('nrm-locked');
      /* 260 = --nr-mov-lenta (250ms, transición del panel) + margen; si cambia el token, cambiar aquí */
      window.setTimeout(resetStack, 260);
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
    }

    function openPanel(id) {
      var p = document.getElementById(id);
      if (!p) return;
      z += 1;
      p.style.zIndex = z;
      p.classList.add('is-open');
      p.setAttribute('aria-hidden', 'false');
      p.scrollTop = 0;
      stack.push(p);
      updateChrome();
    }

    function back() {
      var p = stack.pop();
      if (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
        p.style.zIndex = '';
      }
      updateChrome();
    }

    /* Captura a nivel documento: corre ANTES que el handler de Empire (NavMobile) en el
       botón y corta su propagación → un solo motor (el nuestro), sin que Empire abra su drawer. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-nr-menu-toggle]');
      if (t) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    }, true);

    Array.prototype.forEach.call(root.querySelectorAll('[data-nrm-close]'), function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    backBtn.addEventListener('click', function (e) {
      e.preventDefault();
      back();
    });

    stage.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nrm-open]');
      if (b) {
        e.preventDefault();
        openPanel(b.getAttribute('data-nrm-open'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('nrm--open')) return;
      if (e.key === 'Escape') {
        if (stack.length) back();
        else closeDrawer();
        return;
      }
      /* Trap de Tab dentro del drawer (veredicto H12): primera ↔ última */
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function boot() { init(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* CLÚSTER DE CUENTA v2 (aprobado Jul 5 noche · spec §6) — el avatar del logueado (círculo +
   inicial) vive en el shadow DOM de <shopify-account>. El shadow es ABIERTO → le inyectamos un
   stylesheet que lee las variables --nrh-av-* del tema (heredan al shadow): fondo contextual,
   inicial en Inter NR 600, y para el MIEMBRO la LIEBRE como background (inicial oculta).
   Degradación segura: si Shopify cierra el shadow o cambia sus clases, no pasa nada — queda el
   avatar de fábrica. El componente conserva su click/diálogo intactos (solo estilos). */
(function () {
  var CSS =
    '.account-button__avatar{' +
      'background-color:var(--nrh-av-bg,#191919) !important;' +
      'background-image:var(--nrh-av-img,none) !important;' +
      /* 88%: el SVG de la liebre trae ~28% de margen transparente VERTICAL (clipPath y=2.85–17.15 en viewBox 20)
         y el tamaño se rige por el ANCHO → a 88% el dibujo llena el círculo sin desbordar (ajuste Ricardo, Jul 5) */
      'background-size:88% !important;background-position:center !important;background-repeat:no-repeat !important;' +   /* 88% del círculo = tamaño REAL del arte: el token --nr-liebre-avatar trae el viewBox recortado (el SVG del CDN tenía ~28% de aire vertical horneado) */
      'border:var(--nrh-av-borde,0) !important;box-sizing:border-box !important;' +
    '}' +
    '.account-button__avatar-initials{' +
      'display:var(--nrh-av-ini,inline) !important;' +
      'font-family:var(--nr-font-ui,Inter,system-ui,sans-serif) !important;font-weight:600 !important;' +
      'color:var(--nrh-av-color,#fff) !important;' +
    '}';
  function pintar() {
    var pend = false;
    var nodos = document.querySelectorAll('shopify-account');
    Array.prototype.forEach.call(nodos, function (sa) {
      if (sa.__nrAvatarCss) return;
      if (!sa.shadowRoot) { pend = true; return; }   /* el custom element aún no se ha "upgradeado" */
      var st = document.createElement('style');
      st.textContent = CSS;
      sa.shadowRoot.appendChild(st);
      sa.__nrAvatarCss = true;
    });
    return pend;
  }
  var intentos = 0;
  function ciclo() {
    var pend = pintar();
    intentos += 1;
    if (pend && intentos < 40) window.setTimeout(ciclo, 250);   /* hasta ~10s de gracia para el upgrade */
  }
  if (document.readyState !== 'loading') ciclo();
  else document.addEventListener('DOMContentLoaded', ciclo);
})();

/* HOME · nav overlay: al hacer scroll (>umbral) el nav pasa a SÓLIDO (.nrh--scrolled);
   al volver al top vuelve a transparente. El HOVER lo maneja el CSS (:hover). Solo home. */
(function () {
  var header = document.querySelector('.nrh--home');
  if (!header) return;
  var THRESHOLD = 6;
  var ticking = false;
  function apply() {
    var y = window.scrollY || window.pageYOffset || 0;
    header.classList.toggle('nrh--scrolled', y > THRESHOLD);
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  apply();
})();
